import styled from 'styled-components';

export const LoadingStyle = styled.div`
	&& {
		z-index: 9999 !important;
	}
`;
